module.exports = __webpack_public_path__ + "static/home_banner_001-min-7f43a893ec26b965299074638caa5f72.jpg";